<template>
<div
    v-if="isFooter"
    class="h-full flex justify-center items-center text-main text-md dark:bg-darkCardBg bg-gray-50 font-semibold relative overflow-hidden">
    {{ dataFooter }} <div class="absolute w-full top-0 left-0 h-[2px] bg-main shadow-xl"></div>
</div>
<template v-else-if="!data">
    <div class="h-full" :class="localClasses"></div>
</template>
<template v-else>
    <section
        v-if="type === 'text'"
        class="h-full flex flex-col justify-center text-gray-600 dark:text-white/75"
        :class="localClasses"
        @click="$emit('click')">
        <div class="w-full flex flex-wrap items-center text-left px-5 relative">
            <template v-if="fieldName === 'name' && hasError">
                <n-icon
                    class="text-red-500 cursor-pointer text-xl mr-3"
                    @click.prevent.stop="show = !show">
                    <Warning20Regular />
                </n-icon>
                <base-modal-mobile
                    v-model:show="show">
                    <template #default>
                        <div class="text-gray-600 dark:text-white/75 text-xs" v-html="row.exit_error"></div>
                    </template>
                </base-modal-mobile>
            </template>
            <div class="flex-grow flex justify-start items-center text-[10px]">
                <div v-html="data" class="w-full" :class="pofitLosses ? ('font-semibold ' + (+data >= 0 ? 'text-green-500' : 'text-red-500')) : ''"></div>
                <n-icon v-if="interactive" class="text-main ml-2" size="18"><Link48Filled /></n-icon>
            </div>
            
            <slot name="afterData"></slot>
            <div v-if="vitData !== null" class="absolute right-2 top-1/2 -translate-y-1/2">
                <div v-if="vitData > 0" class="flex text-green-500">
                    {{ vitData }}%
                    <n-icon class="mt-1 ml-[1px]">
                        <ArrowUp12Filled />
                    </n-icon>
                </div>

                <div v-else-if="vitData < 0" class="flex text-red-500">
                    {{ vitData }}%
                    <n-icon class="mt-1 ml-[1px]">
                        <ArrowDown12Filled />
                    </n-icon>
                </div>

                <div v-else>{{ vitData }}%</div>
            </div>
            <section v-if="algo" class="mt-2 w-full">
                <n-tag
                    size="tiny"
                    class="px-2 py-1 rounded-2xl font-bold"
                    :bordered="false"
                    :type="algoTagType">
                    <span :class="setColor[algoTagType]" class="text-[10px] uppercase">
                        {{ algo }}
                    </span>
                </n-tag>
            </section>
        </div>
    </section>
    <div
        v-else-if="type === 'date'"
        class="h-full flex flex-col justify-center items-center px-5"
        :class="localClasses"
        @click="$emit('click')">
        <template v-if="data">
            <div class="text-[10px] text-center font-semibold whitespace-nowrap">{{ data[0] }}</div>
            <div class="text-[10px] text-center opacity-70 whitespace-nowrap">{{ data[1] }}</div>
        </template>
    </div>
    <div
        v-else-if="type === 'algo'"
        class="h-full flex justify-center items-center px-5"
        :class="localClasses">
        <n-tag
            size="tiny"
            class="px-2 py-1 rounded-2xl font-bold"
            :bordered="false"
            :type="algoTagType">
            <span :class="setColor[algoTagType]" class="text-[10px] uppercase">
                {{ algo }}
            </span>
        </n-tag>
    </div>
</template>
</template>

<script>
// vue
import { ref, computed, onMounted } from 'vue';

// store
import { useGl } from '@store/ts/gl';

// icons
import { ArrowUp12Filled, ArrowDown12Filled, Link48Filled, Warning20Regular }  from '@vicons/fluent';

export default {
    name: 'cell-text-desktop',
    props: {
        isFooter: {
            type: Boolean,
            default: false,
            required: true,
        },
        dataFooter: {
            default: '',
        },
        data: {
            required: true,
        },
        vitData: {
            default: null,
        },
        interactive: {
            dafult: false,
        },
        type: {
            default: 'text',
        },
        classes: {
            type: String,
        },
        noWhiteSpace: {
            type: Boolean,
            default: true,
        },
        pofitLosses: {
            type: Boolean,
            default: false,
        },
        fieldName: {
            type: String,
        },
        row: {
            type: Object,
            required: true,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        algo: {
            type: String,
            default: '',
        },
    },
    components: {
        Link48Filled,
        Warning20Regular,
        ArrowUp12Filled,
        ArrowDown12Filled,
    },
    setup(props) {
        // vars
        const show = ref(false);

        // store
        const gl = useGl();

        const localClasses = computed(() => {
            return [
                props.interactive
                    ? 'underline cursor-pointer hover:no-underline hover:text-main font-semibold'
                    : null,
                props.noWhiteSpace
                    ? 'whitespace-nowrap'
                    : null,
                props.data?.length > 30
                    ? 'min-w-[200px] whitespace-pre-line'
                    : null,
                props.classes,
            ];
        });

        const isLong = computed(() => props.algo === 'long');
        const algoTagType =  computed(() => isLong.value ? 'success' : 'error');
        const setColor = computed(() => ({
            'success': gl.darkTheme ? 'text-green-500' : 'text-green-700',
            'error': 'text-red-500',
        }));


        onMounted(() => {
            // console.log('data', props.data);
        });

        return {
            show,
            isLong,
            setColor,
            algoTagType,
            localClasses,
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.rbg-profile__type--2) {
    &:after {
        content: '▲';
        color: #5abc19;
        
    }
}

:deep(.rbg-profile__type--3) {
    &:after {
        content: '▼';
        color: #f3731e;
    }
}
</style>